module.exports = __webpack_public_path__ + "media/images/webpage/hotels/108/plan1-1-08275ed179c75077420a20fa95747ae3.webp";